import { GET_LEAD_FORM_FAIL, GET_LEAD_FORM_REQUEST, GET_LEAD_FORM_SUCCESS, 
  LEAD_FORM_SUBMIT_FAIL, LEAD_FORM_SUBMIT_REQUEST, LEAD_FORM_SUBMIT_SUCCESS,
  GET_PRIVACY_POLICY_REQUEST, GET_PRIVACY_POLICY_SUCCESS, GET_PRIVACY_POLICY_FAIL,
  GET_COOKIE_POLICY_REQUEST, GET_COOKIE_POLICY_SUCCESS, GET_COOKIE_POLICY_FAIL,
  GET_GROUP_LANGUAGES_REQUEST, GET_GROUP_LANGUAGES_SUCCESS, GET_GROUP_LANGUAGES_FAIL
} from "../constant";

const initialState = {
  isLoading: false,
  leadFormData: [],
  ss_id: '',
  privacyPolicy: null,
  privacyLoading: false,
  cookiePolicy: null,
  cookieLoading: false,
  groupLanguages: [],
  groupLanguagesLoading: false
}

const leadFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEAD_FORM_REQUEST:
      return {
        ...state,
        isLoading: true,
        leadFormData: []
      }
    case GET_LEAD_FORM_SUCCESS:
      const sortedFields = action?.payload?.sort((a, b) => Number(a.su_order) - Number(b.su_order))

      return {
        ...state,
        isLoading: false,
        leadFormData: [...sortedFields]
      }
    case GET_LEAD_FORM_FAIL:
      return {
        ...state,
        isLoading: false,
        leadFormData: []
      }
    case LEAD_FORM_SUBMIT_REQUEST:
      return state
    case LEAD_FORM_SUBMIT_SUCCESS:
      return {
        ...state,
        ss_id: action?.payload
      }
    case LEAD_FORM_SUBMIT_FAIL:
      return state
    case GET_PRIVACY_POLICY_REQUEST:
      return {
        ...state,
        privacyLoading: true,
        privacyPolicy: null
      }
    case GET_PRIVACY_POLICY_SUCCESS:
      return {
        ...state,
        privacyLoading: false,
        privacyPolicy: action.payload || null
      }
    case GET_PRIVACY_POLICY_FAIL:
      return {
        ...state,
        privacyLoading: false,
        privacyPolicy: null
      }
    case GET_COOKIE_POLICY_REQUEST:
      return {
        ...state,
        cookieLoading: true,
        cookiePolicy: null
      }
    case GET_COOKIE_POLICY_SUCCESS:
      return {
        ...state,
        cookieLoading: false,
        cookiePolicy: action.payload || null
      }
    case GET_COOKIE_POLICY_FAIL:
      return {
        ...state,
        cookieLoading: false,
        cookiePolicy: null
      }
    case GET_GROUP_LANGUAGES_REQUEST:
      return {
        ...state,
        groupLanguagesLoading: true,
        groupLanguages: []
      }
    case GET_GROUP_LANGUAGES_SUCCESS:
      return {
        ...state,
        groupLanguagesLoading: false,
        groupLanguages: action.payload || []
      }
    case GET_GROUP_LANGUAGES_FAIL:
      return {
        ...state,
        groupLanguagesLoading: false,
        groupLanguages: []
      }
    default:
      return state;
  }
}

export default leadFormReducer